import React from 'react';

/**
 * Interruptor "Incluir partidas como anfitrión". Las partidas que una cuenta
 * juega en su propia sala no suman al D-Rating oficial ni al ranking; con esto
 * el perfil las muestra sumadas.
 */
export const HostFilter: React.FC<{
  hostPlayedGames: number;
  /** "Jugaste" en el perfil propio, "Jugó" en el de otra cuenta. */
  verbo: 'Jugaste' | 'Jugó';
  checked: boolean;
  onChange: (v: boolean) => void;
}> = ({ hostPlayedGames, verbo, checked, onChange }) => (
  <div className="surface p-4 flex items-center gap-3 flex-wrap">
    <label htmlFor="filtro-anfitrion" className="flex-1 min-w-[14rem] cursor-pointer">
      <span className="font-semibold text-ink-100">Incluir partidas como anfitrión</span>
      <span className="block text-ink-500 text-xs">
        {verbo} {hostPlayedGames === 1 ? '1 partida' : `${hostPlayedGames} partidas`} en{' '}
        {verbo === 'Jugaste' ? 'tu' : 'su'} propia sala. No suman al D-Rating oficial ni al ranking.
      </span>
    </label>
    <button
      id="filtro-anfitrion"
      role="switch"
      aria-checked={checked}
      onClick={() => onChange(!checked)}
      className={`relative w-12 h-7 rounded-full transition-colors shrink-0 ${
        checked ? 'bg-sky-500' : 'bg-ink-700'
      }`}
    >
      <span
        className={`absolute top-1 left-1 w-5 h-5 rounded-full bg-white transition-transform ${
          checked ? 'translate-x-5' : ''
        }`}
      />
    </button>
  </div>
);
